import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { filter, map } from 'rxjs/operators';
import { UserStoreModel, UserUIModel } from '../models/user.model';
import { UserStore } from './user.store';

@Injectable({ providedIn: 'root' })
export class UserQuery extends Query<UserStoreModel> {
  constructor(protected readonly store: UserStore) {
    super(store);
  }

  readonly activeUser$ = this.select().pipe(
    filter((state) => !!state.id),
    map((state: UserStoreModel): UserUIModel => state),
  );

  readonly activeUserEmail$ = this.activeUser$.pipe(map((user) => user.email));

  readonly activeUserName$ = this.activeUser$.pipe(map((user) => user.full_name));

  readonly activeUserId$ = this.activeUser$.pipe(map((user) => `${user.id}`));

  getActiveUser(): UserUIModel {
    return this.getValue();
  }

  getActiveUserId(): UserUIModel['id'] {
    return this.getActiveUser().id;
  }

  isUserProfileSetupComplete() {
    const user = this.getActiveUser();
    // When the user registers or is invited, first_name and last_name are empty
    return !!user.first_name && !!user.last_name;
  }
}
